// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__lvSTS {
  width: 60vw;
  max-height: 90vh;
  padding: 30px;
}

.styles_contactContainer__flTAh {
  margin-bottom: 8px;
  border-radius: 10px;
  padding: 0 5px;
  min-height: 100px;
}

.styles_contactContainer__flTAh > div {
  width: 100%;
  margin: 16px 0%;
}

.styles_wrapper__az31J {
  border-radius: unset;
}

.styles_sendButton__F1zpO {
  border-radius: 5px;
  width: 100%;
  height: auto;
  color: #fff;
  margin: 0 !important;
  border: unset !important;
}

.styles_imageClassName__K1KDf {
  width: auto !important;
  margin: 0 20px;
}

.styles_marginBottom__zTMHW {
  margin-bottom: 10px !important;
}

.styles_section__CBL98 {
  width: 100%;
  margin-bottom: 50px;
}

.styles_sectionName__WWUbv {
  width: calc(100% - 140px);
}

.styles_introTitle__lfkwf {
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.styles_introText__X7Q-t {
  color: rgba(0, 0, 0, 0.5);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.styles_introContainer__WbYeV {
  margin: 14px 0;
}

.styles_section__CBL98 input, .styles_section__CBL98 > div > div {
  width: 100% !important;
}

.styles_formContainer__3n7MV {
  border-left-width: 2px;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  width: auto;
  display: flex;
}

.styles_text_area__yKiZD {
  width: 100%;
  height: 100%;
  padding: 20px 10px 0 0;
  font-size: 14px;
  outline: none;
  border-radius: 10px;
  background-color: unset !important;
}

.styles_text_area_border_yellow__lr6vs {
  width: 100%;
  height: 100%;
  padding: 20px 10px 0 0;
  font-size: 14px;
  color: black;
  outline: none;
  border-radius: 10px;
  border: 1px solid #ff9315;
}

.styles_submitItem__M5MDb {
  margin: 0 5px !important;
  cursor: pointer;
  flex-direction: row-reverse;
  border-radius: 6px !important;
  background-color: inherit !important;
  font-size: 16px !important;
  line-height: 25px !important;
  height: auto !important;
}

.styles_kidzyButton__aJTIA {
  border: none;
  color: #713be1 !important;
  opacity: 0.8;
}

.styles_kidzyText__U9rx4 {
  opacity: 0.8;
  font-size: 16px !important;
  line-height: 25px !important;
  color: #713be1 !important;
  height: auto;
  text-align: center;
  width: 100%;
}

.styles_submitItem__M5MDb span {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 25px;
}

.styles_formTitle__6CGzx {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  padding-bottom: 1em;
}

.styles_forgetText__0BpP4 {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  padding-top: 4px;
  margin-bottom: 1em;
}

.styles_inputError__FG72X {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #ff9315;
  margin-top: 8px;
}

.styles_serverError__eivmB {
  background: #ff9315;
  border-radius: 4px;
  color: #ffffff;
  width: 100%;
  height: auto;
  padding: 0.5em;
  margin-bottom: 1em;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.styles_serverError__eivmB span {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  padding: 0 2px;
}

.styles_flexStyle__oSykY {
  flex-direction: row;
  margin: 40px 0;
}

.styles_inputStyle__lH288 {
  width: 353px !important;
  height: 100%;
}

@media only screen and (max-width: 1024px) {
  .styles_flexStyle__oSykY {
    flex-direction: column;
  }
  .styles_flexStyle__oSykY > div:nth-child(2) {
    margin: 0 auto;
    margin-top: 20px;
  }
  .styles_formContainer__3n7MV {
    border-left-width: 0px;
  }
}
@media only screen and (max-width: 800px) {
  .styles_container__lvSTS {
    width: 90vw;
  }
  .styles_force_media__vmMvH {
    padding: 0 10px 0 10px !important;
  }
  .styles_flexStyle__oSykY {
    flex-direction: column-reverse;
    overflow: auto;
    height: calc(100vh - 138px);
    padding-bottom: 20px;
    scrollbar-color: #e3e3e3 transparent;
    scrollbar-width: 8px;
  }
  .styles_flexStyle__oSykY::-webkit-scrollbar {
    background: transparent;
    width: 8px;
  }
  .styles_flexStyle__oSykY::-webkit-scrollbar-thumb {
    background-color: #e3e3e3;
    border-radius: 100px;
    height: 8px;
  }
  .styles_flexStyle__oSykY > div:nth-child(2) {
    margin: 0;
    margin-top: 20px;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .styles_inputStyle__lH288 {
    width: 100% !important;
  }
  .styles_bottomText__SYV1J {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 19px;
    margin: 0;
    padding: 0;
    color: #000000;
    margin-left: 8px;
  }
  .styles_formContainer__3n7MV {
    border-left-width: 0;
    padding-left: 0;
    padding-right: 0;
  }
  .styles_mobileSignup__immb9 {
    justify-content: center;
    flex-direction: row;
    align-items: center;
    width: auto;
    display: flex;
    margin-top: 14px;
    margin-bottom: 14px;
  }
  .styles_mobileSignup__immb9 > span {
    width: auto !important;
  }
  .styles_submitItem__M5MDb {
    border: none;
    font-style: normal !important;
    font-weight: 500 !important;
    font-size: 12px !important;
    line-height: 19px !important;
    width: 100%;
    border: unset !important;
  }
}
.styles_mobileStyle__tonhq {
  width: 100% !important;
  padding-left: 10px;
  padding-right: 10px;
  max-height: 100% !important;
  height: 100%;
  padding-bottom: 0px;
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/CreateGroupModal/styles.module.scss"],"names":[],"mappings":"AACE;EACE,WAAA;EACD,gBAAA;EACA,aAAA;AAAH;;AAME;EAEE,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;AAJJ;;AAME;EACE,WAAA;EACA,eAAA;AAHJ;;AAKE;EAIE,oBAAA;AALJ;;AAQE;EACE,kBAAA;EAEA,WAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EACA,wBAAA;AANJ;;AAQG;EACC,sBAAA;EACA,cAAA;AALJ;;AAOE;EACE,8BAAA;AAJJ;;AAMC;EACC,WAAA;EACA,mBAAA;AAHF;;AAKC;EACC,yBAAA;AAFF;;AAIC;EAEC,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAFF;;AAIC;EACC,yBAAA;EAEA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAFF;;AAIC;EACC,cAAA;AADF;;AAGC;EACC,sBAAA;AAAF;;AAEE;EACE,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;AACJ;;AAEE;EACE,WAAA;EACA,YAAA;EAEA,sBAAA;EACA,eAAA;EAEA,aAAA;EACA,mBAAA;EACA,kCAAA;AADJ;;AAKE;EACE,WAAA;EACA,YAAA;EAEA,sBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AAHJ;;AAME;EACE,wBAAA;EACA,eAAA;EACA,2BAAA;EAEA,6BAAA;EACA,oCAAA;EAEA,0BAAA;EACA,4BAAA;EAEA,uBAAA;AANJ;;AAQE;EACE,YAAA;EAEA,yBAAA;EACA,YAAA;AANJ;;AAQE;EAEE,YAAA;EACA,0BAAA;EACA,4BAAA;EAEA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAPJ;;AASE;EAEE,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;AAPJ;;AAUE;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EAEA,mBAAA;AARJ;;AAWE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAEA,gBAAA;EACA,kBAAA;AATJ;;AAYE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AATJ;;AAYE;EACE,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;AATJ;;AAYE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AATJ;;AAYE;EACE,mBAAA;EACA,cAAA;AATJ;;AAYE;EACE,uBAAA;EAEA,YAAA;AAVJ;;AAaE;EACE;IACE,sBAAA;EAVJ;EAaE;IACE,cAAA;IACA,gBAAA;EAXJ;EAaE;IACE,sBAAA;EAXJ;AACF;AAeE;EACE;IACE,WAAA;EAbJ;EAeE;IACE,iCAAA;EAbJ;EAeE;IACE,8BAAA;IACA,cAAA;IACA,2BAAA;IACA,oBAAA;IAGA,oCAAA;IACA,oBAAA;EAfJ;EAiBE;IAEE,uBAAA;IACA,UAAA;EAhBJ;EAmBE;IACE,yBAAA;IACA,oBAAA;IACA,WAAA;EAjBJ;EAoBE;IACE,SAAA;IACA,gBAAA;IACA,oBAAA;IACA,qBAAA;EAlBJ;EAqBE;IACE,sBAAA;EAnBJ;EAqBE;IACE,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,SAAA;IACA,UAAA;IAEA,cAAA;IACA,gBAAA;EApBJ;EAsBE;IACE,oBAAA;IACA,eAAA;IACA,gBAAA;EApBJ;EAsBE;IACE,uBAAA;IACA,mBAAA;IACA,mBAAA;IACA,WAAA;IACA,aAAA;IACA,gBAAA;IACA,mBAAA;EApBJ;EAsBE;IACE,sBAAA;EApBJ;EAsBE;IACE,YAAA;IACA,6BAAA;IACA,2BAAA;IACA,0BAAA;IACA,4BAAA;IACA,WAAA;IACA,wBAAA;EApBJ;AACF;AAuBE;EACE,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,2BAAA;EACA,YAAA;EACA,mBAAA;AArBJ","sourcesContent":["\n  .container{\n    width:60vw;\n   max-height:90vh;\n   padding:30px;\n  }\n  // .contactContainer{\n  //   max-height: 163px;\n  //   overflow-y: auto;\n  // }\n  .contactContainer{\n    // border: 1px solid #eeeeee;\n    margin-bottom: 8px;\n    border-radius:10px;\n    padding:0 5px;\n    min-height: 100px;\n  }\n  .contactContainer > div{\n    width:100%;\n    margin:16px 0%;\n  }\n  .wrapper{\n    // border: unset;\n    // border:unset !important;\n    // border-bottom: 1px solid rgba(0, 0, 0, 0.50) !important;\n    border-radius: unset;\n    // margin-bottom:50px;\n  }\n  .sendButton{\n    border-radius: 5px;\n    // background: #075B52;\n    width:100%;\n    height: auto;\n    color: #fff;\n    margin:0 !important;\n    border : unset !important;\n   }\n   .imageClassName{\n    width:auto !important;\n    margin:0 20px;\n   }\n  .marginBottom{\n    margin-bottom:10px !important;\n  }\n .section{\n  width:100%;\n  margin-bottom:50px;\n }\n .sectionName{\n  width:calc(100% - 140px )\n }\n .introTitle{\n  // color: #000;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n }\n .introText{\n  color: rgba(0, 0, 0, 0.50);\n  // font-family: Inter;\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n }\n .introContainer{\n  margin:14px 0;\n }\n .section input, .section>div>div{\n  width:100% !important;\n }\n  .formContainer {\n    border-left-width: 2px;\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n    justify-content: flex-start;\n    align-items: flex-start;\n    flex-direction: column;\n    width: auto;\n    display: flex;\n  \n  }\n  .text_area {\n    width: 100%;\n    height: 100%;\n    // background-color: #fafafa;\n    padding: 20px 10px 0 0;\n    font-size: 14px;\n    // color: black;\n    outline: none;\n    border-radius: 10px;\n    background-color:  unset !important;\n    // border: 1px solid #eeeeee;\n  }\n  \n  .text_area_border_yellow {\n    width: 100%;\n    height: 100%;\n    // background-color: #fafafa;\n    padding: 20px 10px 0 0;\n    font-size: 14px;\n    color: black;\n    outline: none;\n    border-radius: 10px;\n    border: 1px solid #ff9315;\n  }\n  \n  .submitItem {\n    margin: 0 5px !important;\n    cursor: pointer;\n    flex-direction: row-reverse;\n    // border: 1px solid #d8000d !important;\n    border-radius: 6px !important;\n    background-color: inherit !important;\n  \n    font-size: 16px !important;\n    line-height: 25px !important;\n    // color: #e30813 !important;\n    height: auto !important;\n  }\n  .kidzyButton{\n    border:none;\n    // color: rgb(41 15 188) !important;\n    color:#713be1 !important;\n    opacity:0.8;\n  }\n  .kidzyText{\n    // color: rgb(41 15 188) !important;\n    opacity:0.8;\n    font-size: 16px !important;\n    line-height: 25px !important;\n    // color: #e30813 !important;\n    color:#713be1 !important;\n    height: auto;\n    text-align:center;\n    width:100%;\n  }\n  .submitItem span {\n    // color: #e30813 !important;\n    font-style: normal;\n    font-weight: bold;\n    font-size: 16px;\n    line-height: 25px;\n  }\n  \n  .formTitle {\n    font-style: normal;\n    font-weight: normal;\n    font-size: 14px;\n    line-height: 20px;\n    // color: #707070;\n    padding-bottom: 1em;\n  }\n  \n  .forgetText {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    // color: #d8000d;\n    padding-top: 4px;\n    margin-bottom: 1em;\n  }\n  \n  .inputError {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #ff9315;\n    margin-top: 8px;\n  }\n  \n  .serverError {\n    background: #ff9315;\n    border-radius: 4px;\n    color: #ffffff;\n    width: 100%;\n    height: auto;\n    padding: 0.5em;\n    margin-bottom: 1em;\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: center;\n  }\n  \n  .serverError span {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 20px;\n    padding: 0 2px;\n  }\n  \n  .flexStyle {\n    flex-direction: row;\n    margin: 40px 0;\n  }\n  \n  .inputStyle {\n    width: 353px !important;\n    // height: 44px;\n    height:100%;\n  }\n  \n  @media only screen and (max-width: 1024px) {\n    .flexStyle {\n      flex-direction: column;\n    }\n  \n    .flexStyle > div:nth-child(2) {\n      margin: 0 auto;\n      margin-top: 20px;\n    }\n    .formContainer {\n      border-left-width: 0px;\n    }\n  }\n  \n  // @media only screen and (max-width: 576px) {\n  @media only screen and (max-width: 800px) {\n    .container{\n      width:90vw;\n    }\n    .force_media {\n      padding: 0 10px 0 10px !important;\n    }\n    .flexStyle {\n      flex-direction: column-reverse;\n      overflow: auto;\n      height: calc( 100vh - 138px);\n      padding-bottom: 20px;\n    \n  \n      scrollbar-color: #e3e3e3 transparent;\n      scrollbar-width: 8px;\n    }\n    .flexStyle::-webkit-scrollbar {\n    \n      background: transparent;\n      width: 8px;\n    }\n    \n    .flexStyle::-webkit-scrollbar-thumb {\n      background-color: #e3e3e3;\n      border-radius: 100px;\n      height: 8px;\n    }\n  \n    .flexStyle > div:nth-child(2) {\n      margin: 0;\n      margin-top: 20px;\n      padding-left: 1.5rem;\n      padding-right: 1.5rem;\n    }\n  \n    .inputStyle {\n      width: 100% !important;\n    }\n    .bottomText {\n      font-style: normal;\n      font-weight: 400;\n      font-size: 12px;\n      line-height: 19px;\n      margin: 0;\n      padding: 0;\n  \n      color: #000000;\n      margin-left: 8px;\n    }\n    .formContainer {\n      border-left-width: 0;\n      padding-left: 0;\n      padding-right: 0;\n    }\n    .mobileSignup {\n      justify-content: center;\n      flex-direction: row;\n      align-items: center;\n      width: auto;\n      display: flex;\n      margin-top: 14px;\n      margin-bottom: 14px;\n    }\n    .mobileSignup > span {\n      width: auto !important;\n    }\n    .submitItem {\n      border: none;\n      font-style: normal !important;\n      font-weight: 500 !important;\n      font-size: 12px !important;\n      line-height: 19px !important;\n      width: 100%;\n      border: unset !important;\n    }\n  }\n  \n  .mobileStyle{\n    width:100% !important;\n    padding-left:10px;\n    padding-right:10px;\n    max-height:100% !important;\n    height:100%;\n    padding-bottom:0px;\n  }\n\n// @media only screen and (max-width: 1200px) {\n//   .contactContainer > div{\n//     width:31%;\n//     margin:10px 1%;\n//   }\n// }\n\n// @media only screen and (max-width: 700px) {\n//   .contactContainer > div{\n//     width:48%;\n//     margin:10px 1%;\n//   }\n// }\n\n// @media only screen and (max-width: 400px) {\n//   .contactContainer > div{\n//     width: 98%;\n//     margin:10px 1%;\n//   }\n// }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__lvSTS`,
	"contactContainer": `styles_contactContainer__flTAh`,
	"wrapper": `styles_wrapper__az31J`,
	"sendButton": `styles_sendButton__F1zpO`,
	"imageClassName": `styles_imageClassName__K1KDf`,
	"marginBottom": `styles_marginBottom__zTMHW`,
	"section": `styles_section__CBL98`,
	"sectionName": `styles_sectionName__WWUbv`,
	"introTitle": `styles_introTitle__lfkwf`,
	"introText": `styles_introText__X7Q-t`,
	"introContainer": `styles_introContainer__WbYeV`,
	"formContainer": `styles_formContainer__3n7MV`,
	"text_area": `styles_text_area__yKiZD`,
	"text_area_border_yellow": `styles_text_area_border_yellow__lr6vs`,
	"submitItem": `styles_submitItem__M5MDb`,
	"kidzyButton": `styles_kidzyButton__aJTIA`,
	"kidzyText": `styles_kidzyText__U9rx4`,
	"formTitle": `styles_formTitle__6CGzx`,
	"forgetText": `styles_forgetText__0BpP4`,
	"inputError": `styles_inputError__FG72X`,
	"serverError": `styles_serverError__eivmB`,
	"flexStyle": `styles_flexStyle__oSykY`,
	"inputStyle": `styles_inputStyle__lH288`,
	"force_media": `styles_force_media__vmMvH`,
	"bottomText": `styles_bottomText__SYV1J`,
	"mobileSignup": `styles_mobileSignup__immb9`,
	"mobileStyle": `styles_mobileStyle__tonhq`
};
export default ___CSS_LOADER_EXPORT___;
